export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mark as unread"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mark as read"])}
        }
      },
      "ru": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отметить не прочитанным"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отметить прочитанным"])}
        }
      },
      "es": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marcar como no leído"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marcar como leído"])}
        }
      },
      "kk": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оқылмаған ретінде белгілеу"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оқылған ретінде белгілеу"])}
        }
      },
      "uz": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O‘qilmagan deb belgilash"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O‘qilgan deb belgilash"])}
        }
      },
      "de": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Als ungelesen markieren"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Als gelesen markieren"])}
        }
      },
      "fr": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marquer comme non lu"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marquer comme lu"])}
        }
      },
      "it": {
        "notification": {
          "markAsUnread": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Segna come non letto"])},
          "markAsRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Segna come letto"])}
        }
      }
    }
  })
}
